import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetAutoManagedCampaigns.graphql';
import { Query, QuerygetAutoManagedCampaignsArgs } from '../../__generated__/globalTypes';

export const useGetAutoManagedCampaignsQuery = (
  options?: QueryHookOptions<Query, QuerygetAutoManagedCampaignsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetAutoManagedCampaignsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetAutoManagedCampaignsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetAutoManagedCampaignsArgs>
): QueryResult<Query, QuerygetAutoManagedCampaignsArgs> & {
  getGetAutoManagedCampaigns: LazyQueryExecFunction<Query, QuerygetAutoManagedCampaignsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetAutoManagedCampaigns, result] = useLazyQuery<Query, QuerygetAutoManagedCampaignsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetAutoManagedCampaigns, ...result };
};

export const useGetAutoManagedCampaignsPromiseQuery = () => {
  const client = useApolloClient();

  const getGetAutoManagedCampaigns = useCallback(
    (options?: Omit<QueryOptions<QuerygetAutoManagedCampaignsArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetAutoManagedCampaignsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetAutoManagedCampaigns };
};
// Suspense Query Hooks
export const useGetAutoManagedCampaignsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetAutoManagedCampaignsArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetAutoManagedCampaignsArgs>(QUERY, {
    ...options
  });

  return result;
};
